import React, {
  useState, useRef, useEffect,
} from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { DataInput, getFont } from '@twnel/web-components';
import getCaretCoordinates from 'textarea-caret';
import SpecDropdown from './SpecDropdown';
import OptionsBar from './OptionsBar';

export const INPUT_TYPES = {
  INPUT: 'input',
  TEXTAREA: 'textarea',
};

export const InteractiveInput = ({
  disabled, invalid, onChange,
  placeholder, refMenuOnKeydown, type,
  value, optionsVisible, fontFamily,
}) => {
  const childrenRef = useRef(null);
  const wrapperRef = useRef(null);
  const font = useSelector(getFont);
  const customFont = fontFamily ? ({
    ...font,
    family: fontFamily,
    size: 13.5,
  }) : font;
  const [isSpecVisible, setspecVisible] = useState(false);
  const [specPosition, setSpecPosition] = useState(false);
  const [width, setWidth] = useState(300);

  useEffect(() => {
    setWidth(wrapperRef.current.offsetWidth);
  }, []);

  const onChangedetectFunctionCharacter = (componentRef) => {
    const { top, left, height } = getCaretCoordinates(componentRef, componentRef.selectionEnd);
    const topPos = top + 20 + 16;
    const leftPos = left + 15;
    setSpecPosition({ topPos, leftPos, height });
    setspecVisible(true);
  };

  const toggleVariablesDisplay = (display) => {
    setspecVisible(display);
  };

  const dropdownOnChange = (variable) => {
    if (childrenRef.current) {
      childrenRef.current.maskInsert(variable);
    }
  };

  return (
    <div style={{ position: 'relative' }} ref={wrapperRef}>
      <OptionsBar childrenRef={childrenRef} disabled={disabled} optionsVisible={optionsVisible}>
        <DataInput
          maxWidth={width}
          font={customFont}
          ref={childrenRef}
          value={value || ''}
          onChange={onChange}
          type={type}
          onVariableType={onChangedetectFunctionCharacter}
          placeholder={placeholder}
          invalid={invalid}
          disabled={disabled}
          refMenuOnKeydown={refMenuOnKeydown}
        />
      </OptionsBar>
      {isSpecVisible ? (
        <SpecDropdown
          position={specPosition}
          toggleDisplay={toggleVariablesDisplay}
          onChange={dropdownOnChange}
        />
      ) : null}
    </div>
  );
};

InteractiveInput.propTypes = {
  disabled: PropTypes.bool,
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  refMenuOnKeydown: PropTypes.bool,
  invalid: PropTypes.bool,
  optionsVisible: PropTypes.bool,
  fontFamily: PropTypes.string,
};

InteractiveInput.defaultProps = {
  disabled: false,
  onChange: () => null,
  placeholder: '',
  refMenuOnKeydown: true,
  invalid: false,
  optionsVisible: false,
  fontFamily: '',
};
